module.exports = __webpack_public_path__ + "media/ลี่ขอเม้า.93c154bc.mp3";